export const LOAD_HARDWARE = 'LOAD_HARDWARE';
